import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Activities from '../components/Activities';
import Partners from '../components/Partners';
import Community from '../components/Community';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const HomePage: React.FC = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <Hero />
      <Activities />
      <Partners />
      <Community />
      <Contact />
      <Footer />
    </div>
  );
};

export default HomePage;
